const quoteFormId = process.env.REACT_APP_FORMSPREE_QUOTE_ID;
const contactFormId = process.env.REACT_APP_FORMSPREE_CONTACT_ID;

export const quoteFormspreeUrl = quoteFormId
  ? `https://formspree.io/f/${quoteFormId}`
  : '';

export const contactFormspreeUrl = contactFormId
  ? `https://formspree.io/f/${contactFormId}`
  : '';
